/**
 * Burbuja de un mensaje de chat: alineada y coloreada por rol, más la burbuja
 * "pensando". Auditoría de reutilización 28/09: la misma silueta estaba en
 * TaChatMode, TaIntakeChat y TaIntakeDetailDialog; el asistente de MFA del
 * Vault es el primero que la usa como componente (las de TA migran cuando se toquen).
 *
 *   <ChatBubble role="assistant"><BrainMarkdown content={text} /></ChatBubble>
 *   <ThinkingBubble label={t('…thinking')} />
 */
import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

export function ChatBubble({ role, children, className }: { role: 'user' | 'assistant'; children: ReactNode; className?: string }) {
  return (
    <div className={cn('flex', role === 'user' ? 'justify-end' : 'justify-start')}>
      <div className={cn('max-w-[92%] rounded-lg px-3 py-2 text-sm', role === 'user' ? 'bg-primary text-primary-foreground' : 'bg-muted text-foreground', className)}>
        {children}
      </div>
    </div>
  );
}

export function ThinkingBubble({ label }: { label: string }) {
  return (
    <div className="flex justify-start">
      <div className="animate-pulse rounded-lg bg-muted px-3 py-2 text-sm text-muted-foreground">{label}</div>
    </div>
  );
}
